/**
 * Play-tab / admin "by market type" presentation order (CAE-523). Distinct from
 * `market_type_allowlist` (what the catalogue admits): this only ranks tabs that are
 * already present on a slate. Unknown types keep first-seen order after the configured set.
 */
/** Caesars V1 order for the curated six Over/Under market types. */
export const DEFAULT_MARKET_TYPE_TAB_ORDER = [
    'Total Hits',
    'Total Pitching Strikeouts',
    'Total Hits + Runs + RBIs',
    'Total Bases',
    'Total RBIs',
    'Total Runs Scored',
];
/**
 * Rank present market types by `configOrder`, then append any types not named there in
 * `present` order (first-seen / insertion order of that list).
 */
export function orderMarketTypes(present, configOrder) {
    const presentSet = new Set(present);
    const ordered = [];
    const seen = new Set();
    for (const marketType of configOrder) {
        if (presentSet.has(marketType) && !seen.has(marketType)) {
            ordered.push(marketType);
            seen.add(marketType);
        }
    }
    for (const marketType of present) {
        if (!seen.has(marketType)) {
            ordered.push(marketType);
            seen.add(marketType);
        }
    }
    return ordered;
}
//# sourceMappingURL=market-type-order.js.map